import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";import Swal from "sweetalert2";
import { getAllBrands, deleteBrand } from "../../../services/MasterSettings/brandServices";
import { paginateData, calculateTotalPages } from "../../../assets/js/script";
import TableHeader from "../../Common/TableComponent/TableHeader";
import EntriesDropdown from "../../Common/TableComponent/EntriesDropdown";
import TablesRow from "../../Common/TableComponent/TablesRow";
import { Pagination } from "../../Common/TableComponent/Pagination";
import { Loading } from "../../Common/OtherElements/Loading";
import { TableDataStatusError } from "../../Common/OtherElements/TableDataStatusError";
import { confirmDelete } from "../../Common/OtherElements/confirmDeleteClone";
import { handleErrors } from "../../../utils/errorHandler";
import { resolveFileUrl } from "../../../utils/fileUrlHelper";
import { usePageLevelAccess } from "../../../hooks/usePageLevelAccess";

export const ManageBrand = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const PageLevelAccessurl = "brand";  const { pageAccessData } = usePageLevelAccess(PageLevelAccessurl);
  const [pageAccessDetails, setPageAccessDetails] = useState([]);
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [manageBrands, setManageBrands] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    if (location.state?.successMessage) {
      toast.success(location.state.successMessage);
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location, navigate]);

  useEffect(() => {
    if (pageAccessData) {      if (!pageAccessData.viewAccess) {
        navigate("/404-error-page");
      } else {
        setPageAccessDetails(pageAccessData);
      }
    } else {
      console.log("No page access details found");
    }
  }, [pageAccessData, navigate]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await getAllBrands();
      setManageBrands(response.data.result || []);
    } catch (error) {
      handleErrors(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const filteredData = manageBrands.filter((item) =>
    (item.brandName || "").toLowerCase().includes(searchQuery.toLowerCase())
  );

  const currentData = paginateData(filteredData, currentPage, entriesPerPage);
  const totalPages = calculateTotalPages(filteredData.length, entriesPerPage);

  const handleEntriesChange = (value) => {
    setEntriesPerPage(value);
    setCurrentPage(1);
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleDelete = async (id) => {
    const confirmed = await confirmDelete("Brand");
    if (confirmed) {
      try {
        await deleteBrand(id);
        setManageBrands((prev) => prev.filter((item) => item.id !== id));
        Swal.fire(
          "Deleted!",
          "The brand has been deleted successfully.",
          "success"
        );
      } catch (error) {
        handleErrors(error);
      }
    }
  };

  return (
    <>
      {pageAccessDetails.viewAccess ? (
        <div className="row">
          <div className="col-xxl-12">
            <div className="card mt-xxl-n5">
              <div className="card-header d-sm-flex align-items-center justify-content-between">
                <h5 className="mb-sm-2 mt-sm-2">Manage Brands</h5>
                {pageAccessDetails.addAccess && (
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => navigate("/brand/add")}
                  >
                    Add Brand
                  </button>
                )}
              </div>
              <div className="card-body manage-amenity-master-card-body">
                <div className="pagination-details-responsive justify-content-between mb-3">
                  <EntriesDropdown
                    entriesPerPage={entriesPerPage}
                    onEntriesChange={handleEntriesChange}
                  />
                  <div>
                    <input
                      type="text"
                      placeholder="Search..."
                      className="form-control mb-2"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                  </div>
                </div>

                {loading ? (
                  <Loading />
                ) : (
                  <div className="table-responsive">
                    <table className="table align-middle table-bordered">
                      <TableHeader
                        columns={[
                          "#",
                          "Brand Image",
                          "Brand Name",
                          "Brand Slug",
                          "Added On",
                          "Action",
                        ]}
                      />
                      <tbody className="manage-page-group-table-values">
                        {currentData.length === 0 ? (
                          <TableDataStatusError colspan="6" />
                        ) : (
                          currentData.map((item, index) => (
                            <TablesRow
                              key={item.id}
                              rowData={{
                                id:
                                  (currentPage - 1) * entriesPerPage +
                                  index +
                                  1,
                                brandImage: item.brandImage ? (
                                  <img
                                    src={resolveFileUrl(item.brandImage)}
                                    alt={item.brandName || "Brand"}
                                    style={{
                                      width: 48,
                                      height: 48,
                                      objectFit: "contain",
                                    }}
                                  />
                                ) : (
                                  "-"
                                ),
                                brandName: item.brandName,
                                brandSlug: item.brandSlug,
                                addedOn: item.addedOn
                                  ? new Date(item.addedOn).toLocaleDateString()
                                  : "-",
                              }}
                              columns={[
                                "id",
                                "brandImage",
                                "brandName",
                                "brandSlug",
                                "addedOn",
                              ]}
                              hideIcons={false}
                              onEdit={() => {
                                navigate(`/brand/update/${item.id}`);
                              }}
                              onDelete={() => handleDelete(item.id)}
                              pageLevelAccessData={pageAccessDetails}
                            />
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                )}

                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  totalEntries={filteredData.length}
                  entriesPerPage={entriesPerPage}
                  onPageChange={handlePageChange}
                />
              </div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
};